import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filingActionAPI } from '../../utilities/api';
import { FilingAction } from '../../utilities/interfaces/FilingAction';

// represents the shape of the slice in state
interface FilingActionState {
  value: any;
  filingAction: FilingAction | null;
}

const initialState: FilingActionState = {
  value: [],
  filingAction: null,
};

const filingActionSlice = createSlice({
  name: 'stateFilingAction',
  initialState,
  reducers: {
    // add new filing item
    addFilingActionItem(state, action: PayloadAction<FilingAction>) {
      // its okay to do this because immer makes it immutable
      state.value.push(action.payload);
    },
    getFilingActionById(state, id) {
      state.value.forEach((element: any) => {
        if (element.id === id) {
          state.filingAction = element;
        }
      });
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllFilingActions.fulfilled, (state, action) => {
      state.value = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAllFilingActions = createAsyncThunk(
  'stateFilingAction/getFilingActionItems',
  async () => {
    const response = await filingActionAPI.getFilingActions();
    return response;
  }
);

export const { addFilingActionItem } = filingActionSlice.actions;
export default filingActionSlice.reducer;
